
import React from 'react';
import { cn } from '@/lib/utils';
import Wave from '@/components/ui/wave';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  badgeText?: string;
  className?: string;
  children?: React.ReactNode; // Added children prop
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  badgeText,
  className,
  children // Added children to component params
}) => {
  return (
    <section className={cn("relative py-24 md:py-32 bg-black overflow-hidden", className)}>
      <div className="container mx-auto px-6 text-center">
        {badgeText && icon && (
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gold/10 text-gold text-sm font-medium mb-6">
            {icon}
            <span>{badgeText}</span>
          </div>
        )}
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-white">
          {title}
        </h1>
        
        {subtitle && (
          <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
            {subtitle}
          </p>
        )}
        
        {children}
      </div>
      
      {/* Wave at the bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <Wave color="#c8a87d" height={80} />
      </div>
    </section>
  );
};

export default PageHeader;
